<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div [formGroup]="formGroup">
    <ng-select
        [id]="controlName"
        [formControlName]="controlName"
        [placeholder]="exportsDropdownPlaceholder"
        [items]="orderedExports"
        [searchFn]="exportSearch"
        [trackByFn]="trackExport"
        [clearable]="allowBlank"
        [multiple]="multiple"
        groupBy="group"
        [hideSelected]="multiple && multipleWrap"
        [maxSelectedItems]="maxSelectedItems()"
        [tabIndex]="tabIndex"
        [fixedPlaceholder]="false"
        [ngClass]="{ 'auto-grow-md small-input': multiple, 'no-multiple-wrap': multiple && !multipleWrap }">
        <ng-template
            ng-label-tmp
            let-item="item"
            let-clear="clear">
            @if (prefix) {
                <span class="text-secondary me-1">{{prefix}}:</span>
            }

            <ng-container
                [ngTemplateOutlet]="label"
                [ngTemplateOutletContext]="{ export: item }">
            </ng-container>
        </ng-template>

        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            @if (prefix) {
                <span class="text-secondary me-1">{{prefix}}:</span>
            }

            @if (showNumSelected) {
                {{ control.value.length }} selected
            } @else {
                @for (item of items; track item.id) {
                    <fdx-clearable-chip
                        [disabled]="disabled"
                        [invalid]="isInvalidExport(item)"
                        (clear)="clear(item)"
                        class="d-flex">
                        <ng-container
                            [ngTemplateOutlet]="label"
                            [ngTemplateOutletContext]="{ export: item }">
                        </ng-container>
                    </fdx-clearable-chip>
                }
            }
        </ng-template>

        <ng-template
            ng-option-tmp
            let-item="item">
            <div class="vstack">
                <ng-container
                    [ngTemplateOutlet]="label"
                    [ngTemplateOutletContext]="{ export: item }">
                </ng-container>

                @if (item.description) {
                    <span class="fs-smaller text-secondary">{{item.description}}</span>
                }
            </div>
        </ng-template>

        @if (multiple) {
            <ng-template
                ng-placeholder-tmp>
                @if (hidePlaceholderExportPrefix) {
                    <span>{{ exportsDropdownPlaceholder }}</span>
                } @else {
                    <span><span class="text-secondary">{{ productTerminologyService.exportText | sentencecase }}s:</span> Any</span>
                }
            </ng-template>
        }

    </ng-select>
</div>

<ng-template
    #label
    let-export="export">
    @let hasIcon = edsUtilsService.isValidExportForEDS(export);
        <div
            class="d-flex align-items-center"
            [class.select-container]="!multiple"
            [class.no-icon]="!hasIcon"
            [class.opacity-50]="export.disabled">
            @if (isEBSDatabase) {
                <div class="edrts-icon-container d-flex align-items-center">
                    @if (hasIcon) {
                        <img
                            class="edrts-icon"
                            [src]="edrtsIcon(export)"
                            alt="EDRTS icon">
                    }
                </div>
            }
            @if (isEDSv2Database) {
                <div class="edrts-icon-container d-flex align-items-center">
                    @if (hasIcon) {
                        <img
                            class="edrts-icon"
                            [src]="edrtsV2Icon(export)"
                            alt="EDRTS v2 icon">
                    }
                </div>
            }
            @if (export.id !== '0' && export.id !== '-1') {
                <img
                    [src]="this.exportDestinationService.getImageForDestination(export.destination)"
                    [alt]="`${export.destination} image`"
                    class="me-2 pe-2 border-end"
                    width="23"
                    height="14"/>
            }
            @if (export.id !== '0') {
                <fa-icon
                    class="me-2"
                    [icon]="getExportIcon(export)"
                    [ngClass]="getExportIconClass(export)"
                    [fixedWidth]="true">
                </fa-icon>
            }
            <span
                [title]="export.name"
                class="titled-text"
                [ngClass]="{
                    'fw-medium': bigCommerceMode.showRestrictedUI(),
                    'text-decoration-line-through text-secondary': exportIsDeactivated(export)
                }">
                {{ export.name }}
            </span>
        </div>
</ng-template>
